import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="sunset-field w-full border-y-4 border-turf" data-id="element-58" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-59" data-mp="1uy2zj31x9h5d">
        <h2 className="font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-60" data-mp="1v05y4bh54ilp">
          Stop winging practice. <span className="text-gold" data-id="element-61" data-mp="1kzwvaesn7yxc">Start running a plan.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/80" data-id="element-62" data-mp="1l29jh9ozv5iu">
          Six volumes, 96 ready-to-run practices and five bonuses. Your whole
          youth lacrosse season — planned by age, printable, with every kid moving.
        </p>

        <div className="mt-7" data-id="element-63" data-mp="179jowgvegsa4">
          <Countdown size="sm" tone="dark" data-id="element-64" data-mp="17abhditpa9w6" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-gold bg-navy-deep/60 px-5 py-4 text-left" data-id="element-65" data-mp="12a7564zts1br">
          <div data-id="element-66" data-mp="xcx57vet879o">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-gold" data-id="element-67" data-mp="3vfor721tbzbu">Complete package</span>
            <span className="text-[15px] font-semibold text-white" data-id="element-68" data-mp="40zfb8jw03fd">No-Lines Lacrosse — 6 Volumes + 5 Bonuses</span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-69" data-mp="3lisgcpofz144">
            <span className="text-[15px] text-white/60 line-through" data-id="element-70" data-mp="3qfsnl3x129wt">$97</span>
            <span className="font-display text-4xl font-bold leading-none text-white" data-id="element-71" data-mp="i0imnz4vjaqm">$27</span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-72" data-mp="mzv9wkznqjtq">
          <CtaButton data-id="element-73" data-mp="mxiuoflaankd">Yes, I want No-Lines Lacrosse — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/65" data-id="element-74" data-mp="81t40455lm9b">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-75" data-mp="2srilkox8rm5p">
              <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-76" data-mp="2xreosly479k7" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}